import { Component, OnInit } from '@angular/core';
import {
  SubscriptionService,
  SuvoUsersClientLibSettingsService,
  CurrentTenantService,
} from '@suvo-bi-users';
import { ITitleSectionInformation } from '../../interfaces/title-section-information.interface';

@Component({
  standalone: false,
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
})
export class PricingComponent implements OnInit {
  titleSectionInformation: ITitleSectionInformation = {
    title: 'Pricing',
    description: 'Find the right package to suit your railway intelligence needs.',
  };

  selectedProducts = [];

  showSeats = false;
  subTotalPrice = 0;
  totalPrice = 0;
  percentDiscount = 0;
  freeTrial = 30;

  productArray = [];

  constructor(
    private readonly settings: SuvoUsersClientLibSettingsService,
    private readonly subscriptionService: SubscriptionService,
    private readonly tenantService: CurrentTenantService,
  ) {}

  async ngOnInit() {
    await this.getProductGroups();
    this.showSeats = this.settings.tempTenantConfig.showOrganisationFunctionality;
    this.calculatePrice();
    this.freeTrial = this.tenantService.currentTenantData.autoTrialPeriod;
  }

  calculatePrice() {
    let tempPrice = 0;
    let totalSelectedProducts = 0;
    this.percentDiscount = 0;
    this.subTotalPrice = 0;
    this.selectedProducts = [];

    for (const product of this.productArray) {
      if (product.selected) {
        tempPrice += product.price;
        totalSelectedProducts++;
        this.selectedProducts.push(product);
      }
    }

    switch (totalSelectedProducts) {
      case 2:
        this.percentDiscount = 5;
        break;
      case 3:
        this.percentDiscount = 7;
        break;
    }
    this.subTotalPrice = tempPrice;
    this.totalPrice = tempPrice * ((100 - this.percentDiscount) / 100);
  }

  async getProductGroups() {
    const productGroups = await this.subscriptionService.getPublicProductGroups(
      this.tenantService.currentTenantData._id,
    );

    for (const productGroup of productGroups) {
      this.productArray.push({
        name: productGroup.name,
        icon: productGroup.icon,
        description: productGroup.description,
        price: 3000, // TODO: make dynamic
        selected: false,
      });
    }
  }
}
